export * from './api';
export * from './employees';
export const employeesNamespace = 'employees';
